import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function auth() {
  return request({
    url:    '/salesforce/auth',
    headers: {'Authorization': localStorageToken()},
    method: 'POST'
  });
}

function products(values) {
  return request({
    url:    '/salesforce/products',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

function policy(values) {
  return request({
    url:    '/salesforce/policy',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

const SalesforceService = {
  auth, products, policy
}

export default SalesforceService;
